import { twMerge } from 'tailwind-merge';
import type { FormFieldTypeId } from '@witmetrics/utils';
import {
  isAnyDateField,
  isAnySelectField,
  isAnyTextField,
  isBooleanField,
} from '@witmetrics/utils/forms';

export const classes = {
  listItem:
    'w-full place-between gap-4 py-2 px-3 mb-2 bg-grey-2 dark:bg-white/[0.06] rounded-xl cursor-pointer border border-grey-2 dark:border-white/10 shadow-none hover:shadow-card transition-all',
  content:
    'place-start gap-4 text-sm text-grey-8 dark:text-mauve-1 font-medium',
  iconWrapper: 'h-10 w-10 rounded-lg shadow-sm place-center shrink-0 bg-blue-1',
  icon: 'text-2xl text-grey-9/60',
  text: 'bg-cyan-1',
  choice: 'bg-green-1',
  date: 'bg-pink-1',
  addIcon: 'add-icon text-grey-7 dark:text-mauve-2',
};

export const styles = {
  listItem: {
    '& .add-icon': {
      opacity: 0,
      transition: 'opacity 0.1s',
    },
    '&:hover .add-icon': {
      opacity: 1,
    },
  },
};

export function buildIconClasses(
  fieldTypeId: FormFieldTypeId,
  className?: string
) {
  let classList = [classes.iconWrapper];
  if (isAnyTextField(fieldTypeId)) {
    classList.push(classes.text);
  } else if (isAnySelectField(fieldTypeId) || isBooleanField(fieldTypeId)) {
    classList.push(classes.choice);
  } else if (isAnyDateField(fieldTypeId)) {
    classList.push(classes.date);
  }
  return twMerge(...classList, className);
}
